
import { apiGet } from '../support/helpers/ApiConnection.Helper';
import ReferralNotificationTracker from '../data-models/ReferralNotificationTracker.DataModel';

export default function getReferralNotificationTracker(referralId: number, abortSignal: AbortSignal): Promise<ReferralNotificationTracker> {
    return apiGet<ReferralNotificationTracker>('/referrals/' + referralId + '/tracker', abortSignal);
}